export const cognitoConfig = {
    userPoolId: "ap-northeast-1_5wK9ibQeS",
    userPoolClientId: "69l3ne268h7l7f2f3bi74iv95r",
}
